import './links-360.scss';

const links360 = {
  init: function() {
    document.querySelector('body').addEventListener('click', ({target}) => {

      if (target.closest('.dialog-360__close-modal') ) {
        const dialog = document.getElementById('dialog-360');
        dialog.close();
        return;
      }

      if (target.closest('.link-360-outside, .link-360-inside, .link-360-mobile') ) {
        const btnToggleModal = document.querySelectorAll('.dialog-360__open-modal, .dialog-360__close-modal');
        const dialog = document.getElementById('dialog-360');
        const linkFrame = document.getElementById('dialog-360__frame');
        linkFrame.src = target.dataset.url;
        dialog.showModal();
        for (const modalBtn of btnToggleModal) {
          modalBtn.setAttribute('aria-expanded', true);
        }
        return;
      }
    });

    const dialog = document.getElementById('dialog-360');

    if( dialog ) {
      dialog.addEventListener('close', () => {
        const btnToggleModal = document.querySelectorAll('.dialog-360__open-modal, .dialog-360__close-modal');
        for (const modalBtn of btnToggleModal) {
          modalBtn.setAttribute('aria-expanded', false);
        }
      });
    }
  }
};

export default links360;
